import {useMutation} from "@tanstack/react-query";
import {PcsSearchParamType} from "../interface";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";
import {exportPurchaseOrders} from "../../../../../api/purchase/PcsApi";

export const useExportPurchaseOrders = () => {
    const {mutate} = useMutation({
        mutationFn: (data: PcsSearchParamType) => exportPurchaseOrders(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `발주_목록_${now}.xlsx`)
            }
        },
    });

    return {mutate};
};
